/* Tasma opinii — zatrzymanie pod palcem i przesuwanie recznie.

   Dlaczego nie zostajemy przy animacji CSS: `animation-play-state: paused`
   umialoby zatrzymac tasme pod kursorem, ale nie da sie do animowanego
   `transform` dolozyc drugiego przesuniecia od reki. Dlatego ten sam ruch
   liczymy w rAF: jedna wlasnosc `transform`, ktora raz przesuwa czas,
   a raz palec.

   Kontrakt z rozkladem sekcji `pp-reviews-marquee`:
   - `.pp-marquee-track` ma `width: max-content` i DOKLADNIE dwie identyczne
     kopie zawartosci; polowa toru to `offsetLeft` pierwszego duplikatu,
     wiec przerwa (`gap`) miedzy kopiami jest wliczona bez zgadywania.
   - `--pp-marquee-duration` to czas jednego przebiegu polowy toru; z niego
     bierze sie predkosc, wiec suwaki w ustawieniach sekcji dzialaja dalej.
   - `.pp-marquee-track--reverse` jedzie w prawo.

   Bez JS zostaje animacja CSS z pp-tokens.css — tasma jedzie, tylko nie da
   sie jej zlapac.

   Przy `prefers-reduced-motion` tasma stoi, ale przesuwanie reka dziala —
   to jest wtedy jedyny sposob, zeby przeczytac dalsze opinie.
*/
(function () {
  var PROG_GESTU = 4; // px — nizej traktujemy ruch jako klikniecie, nie przeciagniecie
  var KROK_KLAWISZA = 140; // px na jedno nacisniecie strzalki

  function przesuniecieZTransformu(element) {
    var zapis = getComputedStyle(element).transform;
    if (!zapis || zapis === 'none') return 0;
    if (window.DOMMatrixReadOnly) {
      try {
        return new DOMMatrixReadOnly(zapis).m41;
      } catch (blad) {
        /* spadamy do recznego parsowania ponizej */
      }
    }
    var liczby = zapis.match(/-?[\d.]+/g);
    if (!liczby) return 0;
    return parseFloat(liczby.length > 6 ? liczby[12] : liczby[4]) || 0;
  }

  function tasma(okno) {
    var tor = okno.querySelector('.pp-marquee-track');
    if (!tor || tor.children.length < 2) return;

    var wolneAnimacje = window.matchMedia('(prefers-reduced-motion: reduce)');
    var wstecz = tor.classList.contains('pp-marquee-track--reverse');
    var stoiBo = { kursor: false, palec: false, poza: false, karta: false };
    var polowa = 0;
    var pikseleNaSekunde = 0;
    var przesuniecie = 0;
    var klatka = null;
    var ostatniCzas = 0;

    function zmierz() {
      // Pierwszy duplikat: druga polowa dzieci to kopia pierwszej.
      var duplikat = tor.children[Math.floor(tor.children.length / 2)];
      polowa = (duplikat ? duplikat.offsetLeft : tor.scrollWidth / 2) || 0;

      var czas = parseFloat(getComputedStyle(tor).getPropertyValue('--pp-marquee-duration')) || 40;
      pikseleNaSekunde = czas > 0 ? polowa / czas : 0;
      zawin();
      rysuj();
    }

    function zawin() {
      if (!polowa) return;
      // Trzymamy sie w (-polowa, 0]: obie kopie sa identyczne, wiec skok
      // o dokladnie polowe toru jest niewidoczny.
      przesuniecie = ((przesuniecie % polowa) - polowa) % polowa;
    }

    function rysuj() {
      tor.style.transform = 'translate3d(' + przesuniecie.toFixed(2) + 'px, 0, 0)';
    }

    function stoi() {
      return stoiBo.kursor || stoiBo.palec || stoiBo.poza || stoiBo.karta;
    }

    function krok(czas) {
      klatka = null;
      if (!ostatniCzas) ostatniCzas = czas;
      // Po powrocie z nieaktywnej karty delta potrafi byc ogromna — obcinamy,
      // zeby tasma nie przeskoczyla o pol ekranu.
      var delta = Math.min((czas - ostatniCzas) / 1000, 0.05);
      ostatniCzas = czas;

      if (!stoi() && !wolneAnimacje.matches && pikseleNaSekunde) {
        przesuniecie += (wstecz ? 1 : -1) * pikseleNaSekunde * delta;
        zawin();
        rysuj();
      }
      zaplanuj();
    }

    function zaplanuj() {
      if (klatka || stoiBo.poza || stoiBo.karta) return;
      klatka = requestAnimationFrame(krok);
    }

    function wznow() {
      ostatniCzas = 0;
      zaplanuj();
    }

    // Przejmujemy ruch od animacji CSS bez przeskoku: zaczynamy dokladnie
    // tam, gdzie stoi klatka animacji w tej chwili.
    przesuniecie = przesuniecieZTransformu(tor);
    tor.style.animation = 'none';
    okno.classList.add('pp-marquee--reka');
    zmierz();

    // --- kursor: staje pod myszka, rusza po zjechaniu -----------------------
    okno.addEventListener('mouseenter', function () {
      stoiBo.kursor = true;
    });
    okno.addEventListener('mouseleave', function () {
      stoiBo.kursor = false;
      wznow();
    });

    // --- palec i mysz: przytrzymanie zatrzymuje, ruch przesuwa --------------
    var wskaznikId = null;
    var startX = 0;
    var startY = 0;
    var poprzednieX = 0;
    var ciagnie = false;

    okno.addEventListener(
      'pointerdown',
      function (zdarzenie) {
        if (zdarzenie.button != null && zdarzenie.button !== 0) return;
        wskaznikId = zdarzenie.pointerId;
        startX = poprzednieX = zdarzenie.clientX;
        startY = zdarzenie.clientY;
        ciagnie = false;
        stoiBo.palec = true;
      },
      { passive: true }
    );

    okno.addEventListener(
      'pointermove',
      function (zdarzenie) {
        if (wskaznikId === null || zdarzenie.pointerId !== wskaznikId) return;

        if (!ciagnie) {
          var doX = zdarzenie.clientX - startX;
          var doY = zdarzenie.clientY - startY;
          // Dopoki nie wiadomo, czy palec jedzie w dol (przewijanie strony),
          // gestu nie zabieramy. Poziomy dopiero po przekroczeniu progu.
          if (Math.abs(doX) < PROG_GESTU || Math.abs(doY) > Math.abs(doX)) return;
          ciagnie = true;
          okno.classList.add('is-ciagniete');
          if (okno.setPointerCapture) {
            try {
              okno.setPointerCapture(wskaznikId);
            } catch (blad) {
              /* Safari potrafi odmowic — przesuwanie dziala i bez przechwycenia. */
            }
          }
        }

        przesuniecie += zdarzenie.clientX - poprzednieX;
        poprzednieX = zdarzenie.clientX;
        zawin();
        rysuj();
      },
      { passive: true }
    );

    function koniecGestu(zdarzenie) {
      if (wskaznikId === null || (zdarzenie && zdarzenie.pointerId !== wskaznikId)) return;
      if (ciagnie && okno.hasPointerCapture && okno.hasPointerCapture(wskaznikId)) {
        okno.releasePointerCapture(wskaznikId);
      }
      wskaznikId = null;
      ciagnie = false;
      okno.classList.remove('is-ciagniete');
      stoiBo.palec = false;
      wznow();
    }

    okno.addEventListener('pointerup', koniecGestu);
    okno.addEventListener('pointercancel', koniecGestu);

    // Przeciagniecie po opinii nie ma konczyc sie zaznaczeniem tekstu.
    okno.addEventListener('dragstart', function (zdarzenie) {
      if (ciagnie) zdarzenie.preventDefault();
    });

    // --- klawiatura: tasma jest polem przewijanym, wiec dostaje fokus -------
    okno.addEventListener('keydown', function (zdarzenie) {
      if (zdarzenie.key !== 'ArrowLeft' && zdarzenie.key !== 'ArrowRight') return;
      przesuniecie += zdarzenie.key === 'ArrowLeft' ? KROK_KLAWISZA : -KROK_KLAWISZA;
      zawin();
      rysuj();
      zdarzenie.preventDefault();
    });
    okno.addEventListener('focusin', function () {
      stoiBo.kursor = true;
    });
    okno.addEventListener('focusout', function () {
      stoiBo.kursor = false;
      wznow();
    });

    // --- poza ekranem i w tle: nie palimy klatek ---------------------------
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (wpisy) {
        stoiBo.poza = !wpisy[0].isIntersecting;
        if (!stoiBo.poza) wznow();
      }).observe(okno);
    } else {
      wznow();
    }

    document.addEventListener('visibilitychange', function () {
      stoiBo.karta = document.hidden;
      if (!stoiBo.karta) wznow();
    });

    if (window.ResizeObserver) {
      var pierwszyPomiar = true;
      new ResizeObserver(function () {
        // Pierwsze wywolanie przychodzi od razu po `observe` — pomiar juz byl.
        if (pierwszyPomiar) {
          pierwszyPomiar = false;
          return;
        }
        zmierz();
      }).observe(tor);
    }

    wznow();
  }

  function start() {
    document.querySelectorAll('[data-pp-marquee]').forEach(tasma);
  }

  // Przejecie tasmy czyta uklad (offsetLeft, transform) zaraz po zapisie stylu,
  // co przy starcie strony wymuszalo przeliczenie ukladu (PageSpeed 1.10.2026).
  // Do tego czasu tasma jedzie na animacji CSS, a `przesuniecieZTransformu`
  // przejmuje ja bez przeskoku, wiec start po zaladowaniu jest niewidoczny.
  function poZaladowaniu() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 });
    else setTimeout(start, 200);
  }

  if (document.readyState === 'complete') {
    poZaladowaniu();
  } else {
    window.addEventListener('load', poZaladowaniu, { once: true });
  }
})();
